import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Endpoints } from './Constants';
import RequestHelper from './RequestHelper';
import { EVENT_TYPES } from '../lib/analytics/constants';
import Logger from '../lib/analytics/logger';
export default {
  /** @typedef {import('./Constants').InboxMessagesResponse} InboxMessagesResponse */

  /** @typedef {import('./Constants').InboxMessageInfo} InboxMessageInfo */

  /** @typedef {import('./Constants').InboxMessageDetails} InboxMessageDetails */

  /** @typedef {import('./Constants').CollectMessageRewardsResponse} CollectMessageRewardsResponse */

  /**
   * Get All Available Inbox Messages
   * @returns {InboxMessagesResponse}
   */
  getInboxMessages: function () {
    var _getInboxMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var messagesResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.GET_INBOX_MESSAGES
              }, true);

            case 3:
              messagesResponse = _context.sent;

              if (!(messagesResponse.success === false)) {
                _context.next = 6;
                break;
              }

              throw Error("[Get-Inbox-Messages-response] ".concat(messagesResponse.error));

            case 6:
              return _context.abrupt("return", messagesResponse);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              throw _context.t0;

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    function getInboxMessages() {
      return _getInboxMessages.apply(this, arguments);
    }

    return getInboxMessages;
  }(),

  /**
   * Get Details of One Particular Inbox Message
   * @returns {InboxMessageDetails}
   */
  getInboxMessageDetails: function () {
    var _getInboxMessageDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id) {
      var messageDetailsResponse;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return RequestHelper.apiGet({
                endpoint: Endpoints.GET_INBOX_MESSAGE_DETAILS + id
              }, true);

            case 3:
              messageDetailsResponse = _context2.sent;

              if (!(messageDetailsResponse.success === false)) {
                _context2.next = 6;
                break;
              }

              throw Error("[Get-Inbox-Message-Details-response] ".concat(messageDetailsResponse.err));

            case 6:
              return _context2.abrupt("return", messageDetailsResponse.details);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              throw _context2.t0;

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));

    function getInboxMessageDetails(_x) {
      return _getInboxMessageDetails.apply(this, arguments);
    }

    return getInboxMessageDetails;
  }(),

  /**
   * Redeem Rewards attached To A Inbox Message
   * @param {Number} messageId
   * @returns {}
   */
  collectMessageRewards: function () {
    var _collectMessageRewards = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
      var collectMessageRewardsResponse, eventPayload;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.COLLECT_MESSAGE_REWARDS,
                body: payload
              }, true);

            case 3:
              collectMessageRewardsResponse = _context3.sent;

              if (!collectMessageRewardsResponse.success) {
                eventPayload = {
                  description: "Unable to redeem reward of message with ID ".concat(id),
                  code: 22
                };
                Logger.sendEvent(EVENT_TYPES.ERROR_CREATED, eventPayload);
              }

              return _context3.abrupt("return", collectMessageRewardsResponse);

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              throw _context3.t0;

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 8]]);
    }));

    function collectMessageRewards(_x2) {
      return _collectMessageRewards.apply(this, arguments);
    }

    return collectMessageRewards;
  }(),

  /**
   * Delete Inbox Message With Id
   */
  deleteInboxMessages: function () {
    var _deleteInboxMessages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
      var messagesResponse;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return RequestHelper.apiGet({
                endpoint: "".concat(Endpoints.DELETE_INBOX_MESSAGE).concat(id)
              }, true);

            case 3:
              messagesResponse = _context4.sent;

              if (!(messagesResponse === false)) {
                _context4.next = 6;
                break;
              }

              throw Error("[Delete-Inbox-Messages-response] ".concat(messagesResponse.error));

            case 6:
              return _context4.abrupt("return", messagesResponse);

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              throw _context4.t0;

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 9]]);
    }));

    function deleteInboxMessages(_x3) {
      return _deleteInboxMessages.apply(this, arguments);
    }

    return deleteInboxMessages;
  }()
};